import { Col, List, Row, Typography } from 'antd'
import React from 'react'
import icoEducation from '../../../images/candidateCard/ico-education.png'
import { Content } from 'antd/es/layout/layout';
import { DICTIONARY } from '../../../utilities/dictionary';
import { useLocation } from 'react-router-dom';
import './index.css'
const { Text } = Typography;

interface Props {
    education: Array<any>
}
const EducationSection: React.FC<Props> = ({ education }) => {
    const location = useLocation();
    return (
        <>
            <Row style={{ width: '100%', height: '20%', display: 'flex', alignItems: 'center', paddingBottom: 20 }}>
                <Col style={{ paddingLeft: 10, paddingRight: 40 }}>
                    <img
                        src={icoEducation}
                        style={{ height: 40, width: 40 }}
                        alt={icoEducation}
                    />
                </Col>

                <Col style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <Text style={{ color: "#129BD4", fontSize: 24 }}>
                        {DICTIONARY['profile_text_education'][location.pathname.split('/')[1] === 'en' ? 'English' : 'French']}
                    </Text>
                </Col>
            </Row>

            <Row className='container-section-education'>
                {
                    education.length > 0 ? (
                        <List
                            dataSource={education}
                            style={{ height: '100%', width: '100%' }}
                            renderItem={(education) => (
                                <Content style={{ height: '100%', width: '100%', marginTop: '3%' }}>
                                    <Row style={{ width: '100%' }}>
                                        <Col xs={{ span: 9, offset: 2 }} sm={{ span: 9, offset: 3 }} md={{ span: 10, offset: 2 }} lg={{ span: 4, offset: 2 }} xl={{ span: 5 }} xxl={{ span: 6, offset: 2 }}>
                                            <Row style={{ width: '100%' }}>
                                                <Col span={23}>
                                                    <Text style={{ fontSize: 17 }}>{education.degree}</Text>
                                                </Col>

                                                <Col span={1} style={{ textAlign: 'center', alignItems: 'center' }}>
                                                    <Text style={{ fontSize: 17, textAlign: 'center' }}>|</Text>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col xs={{ span: 12, offset: 1 }} sm={{ span: 11, offset: 1 }} md={{ span: 11, offset: 1 }} lg={{ span: 6, offset: 1 }} xl={{ span: 5, offset: 1 }} xxl={{ span: 5, offset: 1 }}>
                                            <Row style={{ width: '100%' }}>
                                                <Col span={23} style={{ textAlign: 'start', alignItems: 'center' }}>
                                                    <Text style={{ fontSize: 17 }}>{education.fieldStudy}</Text>
                                                </Col>
                                                <Col span={1} style={{ textAlign: 'center', alignItems: 'center' }}>
                                                    <Text style={{ fontSize: 17, textAlign: 'center' }}>|</Text>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col xs={{ span: 9, offset: 2 }} sm={{ span: 9, offset: 3 }} md={{ span: 10, offset: 2 }} lg={{ span: 6, offset: 1 }} xl={{ span: 5, offset: 1 }} xxl={{ span: 5, offset: 1 }} style={{ textAlign: 'center' }}>
                                            <Row style={{ width: '100%' }}>
                                                <Col span={23} style={{ textAlign: 'start', alignItems: 'center' }}>
                                                    <Text style={{ fontSize: 17, textAlign: 'center' }}> {education.institution}</Text>
                                                </Col>

                                                <Col span={1} style={{ textAlign: 'center', alignItems: 'center' }}>
                                                    <Text style={{ fontSize: 17, textAlign: 'center' }}>|</Text>
                                                </Col>
                                            </Row>

                                        </Col>

                                        <Col xs={{ span: 13 }} sm={{ span: 11, offset: 1 }} md={{ span: 11, offset: 1 }} lg={{ span: 2, offset: 1 }} xl={{ span: 3, offset: 1 }} xxl={{ span: 3, offset: 0 }}>
                                            <Row style={{ width: '100%' }}>
                                                <Col span={21} offset={2} style={{ textAlign: 'start', alignItems: 'center' }}>
                                                    <Text style={{ fontSize: 17 }}>{education.graduationDate !== null && new Date(education.graduationDate.seconds * 1000).getFullYear()}</Text>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Content>
                            )}
                        />
                    ) : (
                        <div style={{ height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                            <Text style={{ color: '#00000040', fontSize: 30 }}>No experience </Text>
                        </div>
                    )
                }

            </Row>
        </>
    )
}

export default EducationSection
